module.exports = __webpack_public_path__ + "c86a5dd613a5a3bda39208a8e4810564.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1041
// module chunks = 0